const transforms = [
  { name: 'aspectRatio', shortName: 'ar' },
  { name: 'crop', shortName: 'c' },
  { name: 'backgroundColor', shortName: 'b' },
  { name: 'gravity', shortName: 'g' },
  { name: 'zoom', shortName: 'z' },
  { name: 'format', shortName: 'f' },
  { name: 'quality', shortName: 'q' },
  { name: 'radius', shortName: 'r' }
]

const transformsNames = transforms.map(t => t.name)

export const getSrcset = (image: any, context: any) => {
  const x2 = { ...context }
  if (x2.width) x2.width *= 2
  if (x2.height) x2.height *= 2
  return image ? `${getFlareVersion(image, context)} 1x, ${getFlareVersion(image, x2)} 2x` : undefined
}

export const getFlareVersion = (item: any, context: any) => {
  const flareParams = [
    { name: 'width', shortName: 'w' },
    { name: 'height', shortName: 'h' },
    ...transforms
  ]

  if (context && item?.meta?.type !== 'DOCUMENT' && item?.meta) {
    if (!item.meta.base_url) return item.meta.url || ''

    const params = []
    for (const param of flareParams) {
      if (context[param.name]) params.push(`${param.shortName}_${context[param.name]}`)
    }

    return `${item.meta.base_url}${params.join(';')}/${item.meta.filename}`
  }

  if (item?.meta?.url) return item.meta.url

  return ''
}

export const getDominantColor = (image: any) => {
  return image?.meta?.dominant_colors?.[0] || '#777'
}

export function getFlareOptions(props: any) {
  const options: { [key: string]: any } = {}
  for (const key of transformsNames) {
    if (props[key]) options[key] = props[key as keyof typeof props]
  }

  if (props.width && !props.height) options.width = +props.width
  if (props.height && !props.width) options.height = +props.height

  if (props.size === 'both') {
    if (props.width) options.width = +props.width
    if (props.height) options.height = +props.height
  } else if (props[props.size]) options[props.size] = +(props[props.size] ?? 0)

  return options
}
